import { makeStyles } from '@material-ui/core/styles'
import { Pill } from '@scoir/pills/dist'

const useStyles = makeStyles((theme) => ({
  draftPill: {
    color: theme.palette.text.disabled,
  },
}))

const StatusCell = ({ status }: { status: string }) => {
  const classes = useStyles()
  switch (status) {
    case 'Draft':
      return <Pill className={classes.draftPill}>{status}</Pill>
    case 'Scheduled':
      return <Pill color="warning">{status}</Pill>
    case 'Delivered':
      return <Pill color="success">{status}</Pill>
    case 'Live':
      return <Pill color="success">{status}</Pill>
    case 'Disabled':
      return <Pill color="error">{status}</Pill>
    default:
      return <Pill>{status}</Pill>
  }
}
export default StatusCell
